import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading-spinner-circle',
  templateUrl: './loading-spinner-circle.component.html',
  styleUrls: ['./loading-spinner-circle.component.scss']
})
export class LoadingSpinnerCircleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
